import axios from 'axios';

const HUBSPOT_DIRECT_BASE = 'https://api.hsforms.com/submissions/v3/integration/submit';
// Portal ID com fallback hardcoded (nao e segredo, esta no embed publico do
// site) para nao depender da env var estar carregada no bundle do navegador.
const HUBSPOT_PORTAL_ID = process.env.GATSBY_HUBSPOT_PORTAL_ID || '7609544';
const TRACE_URL = 'https://www.cloudflare.com/cdn-cgi/trace';
const MAX_RETRIES = 2;
const RETRY_DELAY = 1000;

// Formularios NATIVOS do HubSpot, um por fluxo, que recebem o lead COMPLETO
// (todos os campos, incluindo customer_service). Substituem o envio aos
// formularios coletados (non-HubSpot), que nao mapeiam campos customizados.
const HUBSPOT_FORM_GUIDS = {
  'abrir-empresa': process.env.GATSBY_HUBSPOT_ABRIR_EMPRESA_FORM_GUID
    || 'bef9c4b0-3c6b-48e0-bf84-6164708e5748',
  'trocar-contador': process.env.GATSBY_HUBSPOT_TROCAR_CONTADOR_FORM_GUID
    || 'e0e55a9d-7d5b-40fa-9087-1ecf4926af33',
  // Paralegal (TXM-438): SEM fallback hardcoded de proposito. O formulario
  // nativo desse fluxo ainda vai ser criado no HubSpot, e o GUID e' gerado por
  // lá. Enquanto a env var nao existir, sendDirectToHubspot devolve null e o
  // submit segue sem enviar nada, em vez de postar num GUID inventado (que o
  // HubSpot recusaria com 404 a cada lead). Assim a pagina ja pode ir pro ar
  // com o formulario montado, e ligar depois e' so' configurar a variavel.
  paralegal: process.env.GATSBY_HUBSPOT_PARALEGAL_FORM_GUID,
};

// Campos aceitos por fluxo (nomes internos das propriedades no HubSpot).
// So o que esta listado aqui e enviado, garantindo que o payload sempre case
// com os campos definidos no formulario nativo correspondente.
const HUBSPOT_FORM_FIELDS = {
  'abrir-empresa': ['firstname', 'lastName', 'email', 'phone', 'activity', 'monthly_billing_expectation', 'customer_service'],
  'trocar-contador': ['firstname', 'lastName', 'email', 'phone', 'cnpj', 'customer_service'],
  // Paralegal: um campo de nome so' na tela, entao nao existe lastName aqui.
  // servico_paralegal e' a unica propriedade nova desse fluxo; o resto ja e'
  // nativo do HubSpot ou ja usado pelos outros dois formularios.
  paralegal: ['firstname', 'email', 'phone', 'servico_paralegal', 'customer_service'],
};

// Le o cookie hubspotutk (hutk): e o que o HubSpot usa para atribuir a origem
// e o canal de aquisicao do lead. So existe se o tracking do HubSpot estiver
// ativo na pagina (hs-scripts em dev/homolog; via GTM em producao).
const getHubspotUtk = () => {
  if (typeof document === 'undefined') return undefined;
  const match = document.cookie.match(/(?:^|;\s*)hubspotutk=([^;]+)/);
  return match ? match[1] : undefined;
};

const buildPayload = (data, allowedFields = null) => {
  const fields = Object.entries(data)
    .filter(([key]) => (allowedFields
      ? allowedFields.includes(key)
      : key !== 'cityName' && key !== 'state'))
    .map(([key, value]) => ({
      name: key === 'lastName' ? 'lastname' : key,
      value: value || '',
    }));

  if (data.cityName && data.state) {
    fields.push({
      name: 'cidade_estado',
      value: `${data.cityName} - ${data.state}`,
    });
  }

  const hutk = getHubspotUtk();

  return {
    fields: [...fields],
    context: {
      // hutk liga o lead a navegacao rastreada pelo HubSpot -> atribui a origem
      // (canal de aquisicao). Sem ele, o lead entra sem fonte.
      ...(hutk ? { hutk } : {}),
      pageUri: typeof window !== 'undefined' ? window.location.href : '',
      pageName: typeof document !== 'undefined' ? document.title : '',
    },
  };
};

const fetchUserIp = async () => {
  try {
    const { data } = await axios.get(TRACE_URL, { timeout: 3000 });
    const ipLine = data.split('\n').find((line) => line.startsWith('ip='));
    return ipLine ? ipLine.replace('ip=', '') : null;
  } catch (err) {
    return null;
  }
};

const withRetry = async (fn, retries = MAX_RETRIES, delay = RETRY_DELAY) => {
  try {
    return await fn();
  } catch (error) {
    if (retries <= 0) throw error;
    await new Promise((resolve) => setTimeout(resolve, delay));
    return withRetry(fn, retries - 1, delay);
  }
};

// Envia o lead DIRETO ao HubSpot (api.hsforms.com), usando o GUID do formulario.
// Best-effort: se nao houver portalId/GUID configurado para o tipo, apenas ignora.
const sendDirectToHubspot = async (formType, data = {}) => {
  const formGuid = HUBSPOT_FORM_GUIDS[formType];

  if (!HUBSPOT_PORTAL_ID || !formGuid) {
    return null;
  }

  const payload = buildPayload(data, HUBSPOT_FORM_FIELDS[formType]);
  const ip = await fetchUserIp();

  if (ip) {
    payload.context.ipAddress = ip;
  }

  const url = `${HUBSPOT_DIRECT_BASE}/${HUBSPOT_PORTAL_ID}/${formGuid}`;

  return withRetry(() => axios.post(url, payload, {
    headers: { 'Content-Type': 'application/json' },
    timeout: 10000,
  }));
};

// UM envio por submit: o lead completo vai para o formulario nativo do fluxo
// correspondente (abrir-empresa ou trocar-contador), sem duplicacao.
export const sendToHubspotForm = async (formType, data = {}) => sendDirectToHubspot(formType, data);

export default { sendToHubspotForm };
